<template>
    <div class="lineup" :class="{'lineupDark':isDark}">
        <div class="table">
            <div class="thead">
                <div class="item">
                    <div class="name">教练</div>
                    <div class="position">职位</div>
                    <div class="age">年龄</div>
                    <div class="nationality">国籍</div>
                </div>
            </div>
            <div class="tbody">
                <div class="item" v-for="(item, index) in coach" :key="index">
                    <div class="name">
                        <img :src="item.logo" alt="">
                        <span>{{item.name_s}}</span>
                    </div>
                    <div class="position">{{item.place}}</div>
                    <div class="age">{{item.age}}岁</div>
                    <div class="nationality">{{item.country}}</div>
                </div>
            </div>
        </div>
        <div class="table">
            <div class="thead">
                <div class="item">
                    <div class="name">球员</div>
                    <div class="height">身高</div>
                    <div class="weight">体重</div>
                    <div class="annualSalary">年薪</div>
                    <!-- <div class="contractPeriod">合同期限</div> -->
                </div>
            </div>
            <div class="tbody">
                <div class="item" v-for="(item, index) in player" :key="index" @click="goPlayer(item.player_id)">
                    <div class="nameTwo">
                        <div class="headPortrait">
                            <img :src="item.logo" alt="">
                        </div>
                        <div class="text">
                            <span>{{item.name_s}}</span>
                            <span>
                                {{item.number}}号 {{item.age}}岁 {{item.place}}·{{item.country}}
                            </span>
                        </div>
                    </div>
                    <div class="height">{{item.tallness}}</div>
                    <div class="weight">{{item.weight}}</div>
                    <div class="annualSalary">{{item.salary == '-' || !item.salary ? '-' : parseInt(item.salary) + '万'}}</div>
                    <!-- <div class="contractPeriod">25.06.30</div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getLQTeamLineup } from "@/api/team.js"
import jsbridg from "@/utils/jsbridg.js"
export default {
    name: "lineup",
    data () {
        return {
            team_id: this.$route.query.team_id || 1,
            coach: null,
            player: null
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    created () {
        this.getLineup()
        // window.scrollTo({
        //     top: 0,
        //     behavior: "instant"
        // })
    },
    methods: {
        goPlayer (id) {
            jsbridg.goWebview({
                url: process.env.VUE_APP_DOMAIN + `/teamInfo/player/material?player_id=${id}&top_bar_style=2`,
                jumptype: 2
            });
        },
        async getLineup () {
            const params = {
                team_id: this.team_id
            }
            const res = await getLQTeamLineup(params)
            if (res.errno === 0) {
                if (res.data) {
                    this.coach = res.data.coach
                    this.player = res.data.player
                }
            } else {
                this.$toast(res.errmsg)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.lineup{
    .table{
        .thead,.tbody{
            .item{
                padding-left: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
                div{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .name{
                    flex: 1;
                    justify-content: flex-start;
                }
                .nameTwo{
                    flex: 1;
                    justify-content: flex-start;
                }
                .position{
                    width: 50px;
                }
                .age{
                    width: 50px;
                }
                .nationality{
                    width: 50px;
                }
                .height{
                    width: 30px;
                }
                .weight{
                    width: 30px;
                }
                .annualSalary{
                    width: 70px;
                }
                .contractPeriod{
                    width: 70px;
                }
            }
        }
        .thead{
            .item{
                height: 25px;
                background: #F5F5F5;
                font-size: 12px;
                font-weight: 400;
                color: #666666;
            }
        }
        .tbody{
            .item{
                border-bottom: 1px solid #EEEEEE;
                height: 40px;
                font-size: 12px;
                font-weight: 400;
                color: #333333;
                .name{
                    img{
                        width: 25px;
                        height: 25px;
                        margin-right: 5px;
                    }
                }
                .nameTwo{
                    .headPortrait{
                        img{
                            width: 25px;
                            height: 25px;
                            margin-right: 5px;
                        }
                    }
                    .text{
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        justify-content: center;
                        span{
                            &:last-child{
                                font-size: 10px;
                                font-weight: 400;
                                color: #666666;
                            }
                        }
                    }
                }
                &:last-child{
                    border: none;
                }
            }
        }
    }
}
.lineupDark{
    background-color: #191919;
    min-height: calc(100vh - 200px);
    .table{
        .thead{
            .item{
                background-color: #191919;
                color: #a6a6a6
            }
        }
        .tbody{
            .item{
                border-color: #2f2f2f;
                color: #d3d3d3;
                .nameTwo{
                    .text span{
                        color: #a6a6a6
                    }
                }
            }
        }
    }
}
</style>
